import React, { useContext } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { themeContext } from '../../Context';

import { portfolioSlidesData } from '../../Constant/constants';
import { useMobileView } from '../../hooks/isMobileView';

import './Portfolio.css';

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  const isMobileView = useMobileView();

  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{ color: darkMode ? 'white' : '' }}>Recent Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={isMobileView ? 50 : 30}
        slidesPerView={isMobileView ? 1 : 3}
        grabCursor={true}
        className="portfolio-slider"
      >
        {portfolioSlidesData.map((data) => (
          <SwiperSlide key={data.id} className="swiper-slide">
            <a href={data.to} rel="noreferrer" target="_blank">
              <img
                src={data.image}
                alt="project-img"
                className="portfolio-img"
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Portfolio;
